module.exports = __webpack_public_path__ + "static/scale-model-of-mickey's-toontown-in-fullerton-california-4b132818a7afcdb998219dcdea30bf40.png";